(function () {
  'use strict';

  angular.module('ringbaPortal').component('loginRight', {
    controller: LoginRightController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/login-right/login-right.view.html'
  });

  function LoginRightController(
    $stateParams,
    whitelabelService
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;

    function onInit() {
      vm.showSocialIcons = whitelabelService.checkLocationHostIsBase() && !$stateParams.preview;
    }
  }
})();
